import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_adresse = _resolveComponent("adresse")!
  const _component_antragsteller = _resolveComponent("antragsteller")!
  const _component_vertragsunterlagen_digital = _resolveComponent("vertragsunterlagen-digital")!
  const _component_zahlungsdaten = _resolveComponent("zahlungsdaten")!
  const _component_vorversicherung = _resolveComponent("vorversicherung")!
  const _component_vorschaeden = _resolveComponent("vorschaeden")!
  const _component_hug_mitgliedschaft = _resolveComponent("hug-mitgliedschaft")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      active: 2,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, {
        titel: 
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === true
          ? 'Versichertes Grundstück'
          : 'Versichertes Gebäude'
      
      }, null, 8, ["titel"]),
      _createVNode(_component_adresse, {
        fehler: _ctx.fehler,
        placeholder: true,
        plz: _ctx.piniaStore.state.risikoAnschrift.plz,
        "onUpdate:plz": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.plz) = $event)),
        ort: _ctx.piniaStore.state.risikoAnschrift.ort,
        "onUpdate:ort": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.ort) = $event)),
        strasse: _ctx.piniaStore.state.risikoAnschrift.strasse,
        "onUpdate:strasse": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.strasse) = $event)),
        hausnummer: _ctx.piniaStore.state.risikoAnschrift.hausnummer,
        "onUpdate:hausnummer": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.hausnummer) = $event)),
        "zu-pruefen": _ctx.piniaStore.state.risikoAnschrift.zuPruefen,
        "onUpdate:zuPruefen": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.zuPruefen) = $event)),
        feldNamen: {
        plz: 'risikoPlz',
        ort: 'risikoOrt',
        strasse: 'risikoStrasse',
        hausnummer: 'risikoHausnummer',
      },
        "session-marker": "risikoAnschrift",
        ref: "risikoAdresseRef"
      }, {
        plzOrtLabel: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("PLZ und Ort")
        ])),
        strasseHausnummerLabel: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("Straße und Hausnummer")
        ])),
        _: 1
      }, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "zu-pruefen"]),
      _createVNode(_component_antragsteller, {
        fehler: _ctx.fehler,
        ref: "antragstellerRef"
      }, null, 8, ["fehler"]),
      _createVNode(_component_vertragsunterlagen_digital, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_zahlungsdaten, {
        fehler: _ctx.fehler,
        ref: "zahlungsdatenRef"
      }, null, 8, ["fehler"]),
      _createVNode(_component_vorversicherung, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_vorschaeden, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      (_ctx.zeigeFrageHugNachlass)
        ? (_openBlock(), _createBlock(_component_hug_mitgliedschaft, {
            key: 0,
            fehler: _ctx.fehler
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 4,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                "data-cy": "submitIhreDaten",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.nextPage()))
              }, " Zusammenfassung und Abschluss ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.istSichtbar('modalBeitragsaenderung'))
        ? (_openBlock(), _createBlock(_component_modal, _mergeProps({ key: 1 }, _ctx.modalBeitragsaenderung, {
            onCloseModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.wechsleSichtbarkeit('modalBeitragsaenderung')))
          }), null, 16))
        : _createCommentVNode("", true)
    ])
  ], 64))
}